module.exports = __webpack_public_path__ + "static/media/profile_emptyState.a66bd153.svg";